<template>
  <v-app>
    <v-app-bar
      app
      color="secondary"
      :flat="flat"
      class="px-3"
      height="100"
      :class="{ expand: flat }"
      absolute
    >
      <v-row v-if="isXs" class="d-flex justify-center">
        <img
          src="@/assets/header_movil.png"
          alt="Logo"
          style="max-width: 100%; transform: scale(1.5);"
          class="pt-2 px-5"
        />
      </v-row>

      <v-row v-else style="width: 100%" class="d-flex justify-center">
        <v-col cols="12" class="secondary--text text-center">
          <img src="@/assets/header.png" alt="Logo" height="80" class="pt-2" />
        </v-col>
      </v-row>

      <div v-if="isLogged" class="secondary text-truncate logItem">
        <span
          ><v-btn icon @click="logout" color="black"
            ><v-icon>mdi-logout</v-icon></v-btn
          ></span
        >
      </div>
    </v-app-bar>

    <v-main>
      <HomeRetail class="container" />
      <v-footer class="justify-center" color="#292929" height="130">
        <div
          class="title font-weight-light grey--text text--lighten-1 text-center"
        >
          &copy; {{ new Date().getFullYear() }} — INDO OPTICAL S.L.U.
          <br />
          <span class="caption">Está prohibida la modificación de las imágenes y el uso del logo de Indo sin la previa autorización de Indo Optical</span>
        </div>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
import HomeRetail from "./components/HomeRetail.vue";
import "@/css/main.css";

export default {
  name: "App",

  components: {
    HomeRetail,
  },
  computed: {
    isLogged() {
      return this.$store.state.logueado;
    },
  },

  data: () => ({
    isXs: false,
    drawer: false,
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      window.localStorage.clear();
      this.$router.go();
    },
    onResize() {
      this.isXs = window.innerWidth < 920;
    },
  },
  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
